import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './tailwind.css';
import SightlineWebsite from './SightlineWebsite';

// The internal admin (quote builder) is a separate, self-contained SPA mounted
// only when the URL is under /admin — it is lazy-loaded so the public marketing
// site never pays for its auth/router/admin code.
const AdminApp = React.lazy(() => import('./AdminApp'));

const container = document.getElementById('root');
const isAdminRoute = window.location.pathname.startsWith('/admin');

createRoot(container).render(
  <React.StrictMode>
    {isAdminRoute ? (
      <Suspense fallback={<div className="page-loading">Loading…</div>}>
        <AdminApp />
      </Suspense>
    ) : (
      <SightlineWebsite />
    )}
  </React.StrictMode>
);
